import { request } from '../../utils/requests';

const API_BASE = '/documentGenerated';

export const createDocumentGenerated = async (documentData) => {
  try {
    const response = await request.post(API_BASE, documentData);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar documento:', error);
    throw error;
  }
};

export const listDocumentsByClient = async (clientId) => {
  try {
    const response = await request.get(`${API_BASE}/client/${clientId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao listar documentos do cliente:', error);
    throw error;
  }
};

export const getDocumentById = async (documentId) => {
  try {
    const response = await request.get(`${API_BASE}/${documentId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar documento:', error);
    throw error;
  }
};

export const updateDocument = async (documentId, updateData) => {
  try {
    const response = await request.put(`${API_BASE}/${documentId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar documento:', error);
    throw error;
  }
};

export const finalizeDocument = async (documentId, payload = {}) => {
  try {
    const response = await request.post(`${API_BASE}/${documentId}/finalize`, payload);
    return response.data;
  } catch (error) {
    console.error('Erro ao finalizar documento:', error);
    throw error;
  }
};

// Preview: renderiza HTML em PDF via document-service (mesma engine do
// "Finalizar PDF"), sem persistir nada. Body: { html, title, watermark? }
export const renderPdfPreview = async (payload) => {
  const response = await request.post(`${API_BASE}/render-pdf`, payload, {
    responseType: 'blob',
  });
  return response.data;
};

export const deleteDocument = async (documentId) => {
  try {
    const response = await request.delete(`${API_BASE}/${documentId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao excluir documento:', error);
    throw error;
  }
};

export const generateDocumentFromTemplate = async (clientId, templateId, variables = {}) => {
  try {
    const response = await request.post(`${API_BASE}/generate`, {
      clientId,
      templateId,
      variables
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao gerar documento:', error);
    throw error;
  }
};

export const generateMultipleDocumentsFromTemplates = async (clientId, templateIds, variables = {}) => {
  try {
    const response = await request.post(`${API_BASE}/generate-multiple`, {
      clientId,
      templateIds,
      variables
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao gerar documentos múltiplos:', error);
    throw error;
  }
};

// Renderizar HTML -> PDF no backend (marca d'água aplicada só na saída)
export const renderPdfFromHtml = async ({ html, title, watermark }) => {
  try {
    const response = await request.post(
      `${API_BASE}/render-pdf`,
      { html, title, watermark },
      { responseType: 'blob' }
    )
    return response
  } catch (error) {
    console.error('Erro ao renderizar PDF:', error)
    throw error
  }
}
